module.exports = __webpack_public_path__ + "static/assets/2eeef5396c69834c982b3160686c137e.png";